/** Non-secret flag for Edge middleware. The JWT stays in localStorage. */
export const AUTH_SESSION_COOKIE = "aunix_session";
export const AUTH_SESSION_VALUE = "1";
